import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BulkPermissionRequest, BulkManagePermissionsResponse, FilePermissionsResponse } from '../models/permissions.model';
import { API_BASE_URL } from '../config/app-settings.tokens';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private apiUrl = inject(API_BASE_URL);

  constructor(private http: HttpClient) {}

  /**
   * Get all file permissions (file access list)
   * @param fileId - The file ID
   * @param pageNumber - Page number (default 1)
   * @param pageSize - Number of results per page (default 10)
   * @returns Observable<FilePermissionsResponse>
   */
  getFilePermissions(fileId: number, pageNumber: number = 1, pageSize: number = 10): Observable<FilePermissionsResponse> {
    const url = `${this.apiUrl}/api/v1/internal/permissions/files/${fileId}`;
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<FilePermissionsResponse>(url, { params });
  }

  /**
   * Bulk manage permissions for a file
   * Sends the complete list of users who should have access.
   * API determines which permissions to grant, keep, or revoke.
   * @param fileId - The file ID
   * @param iamUserIds - Array of IAM user IDs who should have access
   * @returns Observable<BulkManagePermissionsResponse>
   */
  bulkManagePermissions(fileId: number, iamUserIds: number[]): Observable<BulkManagePermissionsResponse> {
    const url = `${this.apiUrl}/api/v1/internal/permissions/files/${fileId}/users/bulk-manage`;
    const payload: BulkPermissionRequest = { iamUserIds };
    return this.http.post<BulkManagePermissionsResponse>(url, payload);
  }
}
